import React, { useState } from "react";
import { get } from "lodash";
import { Field } from "redux-form";
import { useParams } from "react-router-dom";
import { required, email } from "redux-form-validators";

import { scrollToTop } from "../../../../helpers/animation";
import { Button, Checkbox, Input } from "../../../../components/Field";
import PlanList from "./PlanList";
import Link from "../../../../components/Link";
import Text from "../../../../components/Text";
import AsyncForm from "../../../../components/AsyncForm";

import style from "../style.module.css";
import Title from "../../../../components/Title";

export default function PersonalDetails({ nextStep, personalDetails = {}, setPersonalDetails, setPlanId, setPlanType }) {
    const Params = useParams();
    const [userPlan, setUserPlan] = useState(null);
    const [urlplan, setUrlPlan] = useState(get(Params, 'plan', ''));
    return (
        <div className={style.personalDetails}>
            <AsyncForm
                id="gstep01"
                url="/gift-membership"
                permission={false}
                showToastOnSuccess={false}
                onSave={({ data }) => {
                    setPersonalDetails(data);
                    nextStep('ConfirmDetails');
                    scrollToTop();
                }}
                initialValues={
                    {
                        send_immediate: 1
                    }
                }
                render={({ fetching, formValues, change }) => {
                    return (
                        <div className={style.form}>
                            <div className={style.formRow}>
                                <Text className="formTitle" text="CHoose a Membership plan" />
                                <Text className="formSubTitle" text="Select membership type*" />
                            </div>
                            <div className={style.formRow}>
                                <PlanList
                                    urlplan={urlplan}
                                    setUrlPlan={setUrlPlan}
                                    userplan={userPlan}
                                    setuserplan={setUserPlan}
                                    setPlanId={setPlanId}
                                    setPlanType={setPlanType}
                                />
                            </div>
                            <div className={style.formRow}>
                                <Text className="formTitle" text="TO: recipient DETAILS" />
                            </div>
                            <div className={style.formRow}>
                                <Field
                                    name="to.first_name"
                                    component={Input}
                                    validate={required()}
                                    required={true}
                                    placeholder="Enter your first name"
                                    label="First name"
                                />
                            </div>
                            <div className={style.formRow}>
                                <Field
                                    name="to.surname"
                                    component={Input}
                                    validate={required()}
                                    label="Surname"
                                    required={true}
                                    placeholder="Enter your surname"
                                />
                            </div>
                            <div className={`${style.formRow} ${style.bottomBorder}`}>
                                <Field
                                    name="to.email"
                                    component={Input}
                                    validate={[required(), email()]}
                                    label="Email address"
                                    required={true}
                                    placeholder="Enter email address"
                                />
                            </div>
                            <div className={style.formRow}>
                                <Text className="formTitle" text="from: your details" />
                            </div>
                            <div className={style.formRow}>
                                <Field
                                    name="from.first_name"
                                    component={Input}
                                    validate={required()}
                                    required={true}
                                    placeholder="Enter your first name"
                                    label="First name"
                                />
                            </div>
                            <div className={style.formRow}>
                                <Field
                                    name="from.surname"
                                    component={Input}
                                    validate={required()}
                                    label="Surname"
                                    required={true}
                                    placeholder="Enter your surname"
                                />
                            </div>
                            <div className={`${style.formRow}`}>
                                <Field
                                    name="from.email"
                                    component={Input}
                                    validate={[required(), email()]}
                                    label="Email address"
                                    required={true}
                                    placeholder="Enter email address"
                                />
                            </div>
                            <div className={`${style.formRow} ${style.bottomBorder}`}>
                                <Field
                                    name="message"
                                    component={Input}
                                    label="Personalised message"
                                    placeholder="Optional gift message"
                                    type="textarea"
                                />
                            </div>
                            <div className={style.formRow}>
                                <Field
                                    name="send_immediate"
                                    component={Checkbox}
                                    checkValue={1}
                                    unCheckedValue={0}
                                    label="Send Immediate"
                                />
                            </div>
                            {
                                get(formValues, 'send_immediate', 0) === 0 && (
                                    <div className={`${style.formRow}`}>
                                        <Field
                                            name="delivery_date"
                                            component={Input}
                                            label="Delivery date"
                                            placeholder="Select a date for your gift membership (optional)"
                                            type="date"
                                        />
                                    </div>
                                )
                            }
                            <div className={`${style.formRow} ${style.message}`}>
                                <Title tag="p">Gift email with redeem instructions will be sent to recipient at 10am GMT on the selected delivery date. If no delivery date is chosen, gift email will be sent to recipient immediately upon purchase.</Title>
                            </div>
                            <div className={`${style.formRow} ${style.checkBoxRow}`}>
                                <Field
                                    name="terms"
                                    component={Checkbox}
                                    checkValue={1}
                                    validate={required()}
                                    link="terms-conditions"
                                    label="I agree to"
                                />
                                <Link
                                    className={style.termsLink}
                                    target="_blank"
                                    to={"terms-conditions"}
                                >
                                    {"terms & conditions"}
                                </Link>*
                            </div>
                            <div className={style.formRow}>
                                <Field
                                    name="marketing_opt_in"
                                    component={Checkbox}
                                    checkValue={1}
                                    unCheckedValue={0}
                                    label="I agree to opt in for marketing purposes"
                                    onChange={(newValue, field) => {
                                        change("subscribe", newValue === 1 ? 1 : 0);
                                    }}
                                />
                            </div>
                            {
                                get(formValues, 'marketing_opt_in', 0) === 1 && (
                                    <div className={style.formRow}>
                                        <Field
                                            name="subscribe"
                                            component={Checkbox}
                                            checkValue={1}
                                            unCheckedValue={0}
                                            label="Subscribe to the ww2HQ Newsletter"
                                        />
                                    </div>
                                )
                            }
                            <div className={`${style.formRow} ${style.formSubmit}`}>
                                <Button
                                    submit={true}
                                    fetching={fetching}
                                    label="NEXT"
                                />
                            </div>
                        </div>
                    )
                }}
            />
        </div>
    )
}